import styles from './date-range-picker.module.scss';
import { ReactNode } from 'react';
import { DateRangePicker as MaterialDateRangePicker } from '@mui/x-date-pickers-pro/DateRangePicker';
import { StaticDateRangePicker as MaterialStaticDateRangePicker } from '@mui/x-date-pickers-pro/StaticDateRangePicker';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import nb from "date-fns/locale/nb";

/* eslint-disable-next-line */
export interface DateRangePickerProps {
  onChange: (event: any) => void,
  renderInput: any,
  value: any,
  // acceptRegex?: any,
  // allowSameDateSelection?: boolean,
  // calendars?: 1 | 2 | 3,
  // cancelText?: ReactNode,
  // className?: string,
  // clearable?: boolean,
  // clearText?: ReactNode,
  // components?: {
  //   LeftArrowButton?: any,
  //   LeftArrowIcon?: any,
  //   OpenPickerIcon?: any,
  //   RightArrowButton?: any,
  //   RightArrowIcon?: any,
  //   SwitchViewButton?: any,
  //   SwitchViewIcon?: any
  // },
  // componentsProps?: {
  //   leftArrowButton?: object,
  //   rightArrowButton?: object,
  //   switchViewButton?: object
  // },
  // defaultCalendarMonth?: any,
  // desktopModeMediaQuery?: string,
  // DialogProps?: object,
  // disableAutoMonthSwitching?: boolean,
  // disableCloseOnSelect?: boolean,
  disabled?: boolean,
  // disableHighlightToday?: boolean,
  // disableMaskedInput?: boolean,
  // disableOpenPicker?: boolean,
  endText?: ReactNode,
  // getOpenDialogAriaText?: () => void,
  // getViewSwitchingButtonText?: () => void,
  // InputAdornmentProps?: object,
  inputFormat?: string,
  // inputRef?: any,
  // leftArrowButtonText?: string,
  // loading?: boolean,
  mask?: string,
  // maxDate?: any,
  // minDate?: any,
  // okText?: ReactNode,
  // onAccept?: () => void,
  // onClose?: () => void,
  // onError?: () => void,
  // onMonthChange?: () => void,
  // onOpen?: () => void,
  // onViewChange?: () => void,
  open?: boolean,
  // OpenPickerButtonProps?: object,
  // orientation?: 'landscape' | 'portrait',
  // PaperProps?: object,
  // PopperProps?: object,
  // readOnly?: boolean,
  // reduceAnimations?: boolean,
  // renderDay?: () => void,
  // renderLoading?: () => void,
  // rifmFormatter?: () => void,
  // rightArrowButtonText?: string,
  // shouldDisableDate?: () => void,
  // shouldDisableYear?: () => void,
  // showDaysOutsideCurrentMonth?: boolean,
  // showTodayButton?: boolean,
  // showToolbar?: boolean,
  startText?: ReactNode,
  // todayText?: ReactNode,
  // ToolbarComponent?: any,
  // toolbarFormat?: string,
  // toolbarPlaceholder?: ReactNode,
  // toolbarTitle?: ReactNode,
  // TransitionComponent?: any,
  label?: string
}

export interface StaticDateRangePickerProps {
  onChange: (event: any) => void,
  renderInput: any,
  value: any,
  // acceptRegex?: any,
  // allowSameDateSelection?: boolean,
  // calendars?: 1 | 2 | 3,
  // className?: string,
  // components?: {
  //   LeftArrowButton?: any,
  //   LeftArrowIcon?: any,
  //   OpenPickerIcon?: any,
  //   RightArrowButton?: any,
  //   RightArrowIcon?: any,
  //   SwitchViewButton?: any,
  //   SwitchViewIcon?: any
  // },
  // componentsProps?: object,
  // defaultCalendarMonth?: any,
  // disableAutoMonthSwitching?: boolean,
  // disableCloseOnSelect?: boolean,
  disabled?: boolean,
  // disableHighlightToday?: boolean,
  // disableMaskedInput?: boolean,
  // disableOpenPicker?: boolean,
  displayStaticWrapperAs?: 'desktop' | 'mobile',
  endText?: ReactNode,
  // getOpenDialogAriaText?: () => void,
  // getViewSwitchingButtonText?: () => void,
  // InputAdornmentProps?: object,
  // inputFormat?: string,
  // inputRef?: any,
  // leftArrowButtonText?: string,
  // loading?: boolean,
  mask?: string,
  // maxDate?: any,
  // minDate?: any,
  // onAccept?: () => void,
  // onClose?: () => void,
  // onError?: () => void,
  // onMonthChange?: () => void,
  // onOpen?: () => void,
  // onViewChange?: () => void,
  // open?: boolean,
  // OpenPickerButtonProps?: object,
  // orientation?: 'landscape' | 'portrait',
  // readOnly?: boolean,
  // reduceAnimations?: boolean,
  // renderDay?: () => void,
  // renderLoading?: () => void,
  // rifmFormatter?: () => void,
  // rightArrowButtonText?: string,
  // shouldDisableDate?: () => void,
  // shouldDisableYear?: () => void,
  // showDaysOutsideCurrentMonth?: boolean,
  // showToolbar?: boolean,
  startText?: ReactNode,
  // ToolbarComponent?: any,
  // toolbarFormat?: string,
  // toolbarPlaceholder?: ReactNode,
  // toolbarTitle?: ReactNode
}

export function DateRangePicker(props: DateRangePickerProps) {
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} locale={nb}>
      <MaterialDateRangePicker
        value={props.value}
        onChange={props.onChange}
        renderInput={props.renderInput}
        inputFormat={props.inputFormat}
        mask={props.mask}
        disabled={props.disabled}
        open={props.open}
        startText={props.startText}
        endText={props.endText}
        label={props.label}
      />
    </LocalizationProvider>
  );
}

export function StaticDateRangePicker(props: StaticDateRangePickerProps) {
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} locale={nb}>
      <MaterialStaticDateRangePicker
        displayStaticWrapperAs={props.displayStaticWrapperAs}
        value={props.value}
        onChange={props.onChange}
        renderInput={props.renderInput}
        disabled={props.disabled}
        startText={props.startText}
        endText={props.endText}
        mask={props.mask}
      />
    </LocalizationProvider>
  );
}

export default DateRangePicker;